import React, { useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { LocContext } from '../../contexts/location/LocContext';
import { LOCATIONS } from '../../contexts/location/types';

const Logo = ({ white, stroke, noType, className }) => {
	const typeRef = useRef(null);

	const { setLocation } = useContext(LocContext);

	useEffect(() => {
		white && typeRef.current.classList.add('logo-white');
		stroke && typeRef.current.classList.add('logo-stroke');

		// eslint-disable-next-line
	}, []);

	if (noType)
		return (
			<Link
				to='/'
				onClick={() => (
					setLocation(LOCATIONS.HOME), window.scrollTo({ top: 0 })
				)}
			>
				<svg
					xmlns='http://www.w3.org/2000/svg'
					xmlnsXlink='http://www.w3.org/1999/xlink'
					viewBox='0 0 105.72 116.62'
					preserveAspectRatio='xMidYMid meet'
					id='svg-logo'
					className={`no-type ${className}`}
				>
					<defs>
						<linearGradient
							id='linear-gradient'
							x1='49.22'
							y1='57.78'
							x2='104.66'
							y2='57.78'
							gradientUnits='userSpaceOnUse'
						>
							<stop offset='0' stopColor='#fff2c2' />
							<stop offset='0.01' stopColor='#ffeeb3' />
							<stop offset='0.04' stopColor='#ffe690' />
							<stop offset='0.07' stopColor='#ffe075' />
							<stop offset='0.11' stopColor='#ffdc61' />
							<stop offset='0.14' stopColor='#ffd956' />
							<stop offset='0.17' stopColor='#ffd852' />
							<stop offset='0.35' stopColor='#fff5d1' />
							<stop offset='0.57' stopColor='#f1b71b' />
							<stop offset='0.7' stopColor='#cf842d' />
							<stop offset='0.83' stopColor='#ffd647' />
							<stop offset='0.83' stopColor='#ffd649' />
							<stop offset='0.87' stopColor='#ffe27a' />
							<stop offset='0.91' stopColor='#ffeaa1' />
							<stop offset='0.95' stopColor='#fff1bd' />
							<stop offset='0.98' stopColor='#fff5ce' />
							<stop offset='1' stopColor='#fff6d4' />
						</linearGradient>
						<linearGradient
							id='linear-gradient-2'
							x1='49.22'
							y1='57.78'
							x2='104.99'
							y2='57.78'
							gradientUnits='userSpaceOnUse'
						>
							<stop offset='0' stopColor='#fff8e8' />
							<stop offset='0.01' stopColor='#fff7e1' />
							<stop offset='0.04' stopColor='#fff0be' />
							<stop offset='0.07' stopColor='#ffeba3' />
							<stop offset='0.1' stopColor='#ffe88f' />
							<stop offset='0.14' stopColor='#ffe684' />
							<stop offset='0.17' stopColor='#ffe580' />
							<stop offset='0.35' stopColor='#fff6db' />
							<stop offset='0.43' stopColor='#ffe27c' />
							<stop offset='0.54' stopColor='#fcda3f' />
							<stop offset='0.63' stopColor='#e7831d' />
							<stop offset='0.7' stopColor='#d0912c' />
							<stop offset='0.83' stopColor='#fdda2b' />
							<stop offset='0.86' stopColor='#fde153' />
							<stop offset='0.89' stopColor='#fee984' />
							<stop offset='0.92' stopColor='#feefab' />
							<stop offset='0.95' stopColor='#fff4c7' />
							<stop offset='0.98' stopColor='#fff7d8' />
							<stop offset='1' stopColor='#fff8de' />
						</linearGradient>
						<linearGradient
							id='linear-gradient-3'
							x1='697.13'
							y1='57.79'
							x2='752.58'
							y2='57.79'
							gradientTransform='matrix(-1, 0, 0, 1, 753.72, 0)'
							xlinkHref='#linear-gradient'
						/>
						<linearGradient
							id='linear-gradient-4'
							x1='697.13'
							y1='57.79'
							x2='752.9'
							y2='57.79'
							gradientTransform='matrix(-1, 0, 0, 1, 753.72, 0)'
							xlinkHref='#linear-gradient-2'
						/>
						<linearGradient
							id='linear-gradient-5'
							x1='33.51'
							y1='70.26'
							x2='63.56'
							y2='70.26'
							gradientTransform='matrix(0.96, 0, 0, 1, 6.61, -0.17)'
							gradientUnits='userSpaceOnUse'
						>
							<stop offset='0' stopColor='#ffefb5' />
							<stop offset='0.03' stopColor='#ffe68e' />
							<stop offset='0.05' stopColor='#ffdf6b' />
							<stop offset='0.08' stopColor='#ffd950' />
							<stop offset='0.11' stopColor='#ffd43c' />
							<stop offset='0.14' stopColor='#ffd231' />
							<stop offset='0.17' stopColor='#ffd12d' />
							<stop offset='0.35' stopColor='#fff3c7' />
							<stop offset='0.54' stopColor='#ffc90d' />
							<stop offset='0.7' stopColor='#b76528' />
							<stop offset='0.83' stopColor='#ffc708' />
							<stop offset='0.87' stopColor='#ffd441' />
							<stop offset='0.9' stopColor='#ffe072' />
							<stop offset='0.93' stopColor='#ffe999' />
							<stop offset='0.96' stopColor='#fff0b5' />
							<stop offset='0.98' stopColor='#fff4c6' />
							<stop offset='1' stopColor='#fff5cc' />
						</linearGradient>
						<linearGradient
							id='linear-gradient-6'
							x1='27.65'
							y1='70.66'
							x2='58.13'
							y2='70.66'
							gradientTransform='matrix(0.93, 0, 0, 1, 13.35, 0.23)'
							xlinkHref='#linear-gradient-2'
						/>
						<linearGradient
							id='linear-gradient-7'
							x1='183.63'
							y1='218.34'
							x2='183.63'
							y2='226.68'
							gradientTransform='translate(-130.36 -193.02)'
							gradientUnits='userSpaceOnUse'
						>
							<stop offset='0' stopColor='#2b2b2b' />
							<stop offset='0.1' stopColor='#232323' />
							<stop offset='0.39' stopColor='#0f0f0f' />
							<stop offset='0.69' stopColor='#040404' />
							<stop offset='1' />
						</linearGradient>
						<linearGradient
							id='linear-gradient-8'
							x1='183.63'
							y1='218.7'
							x2='183.63'
							y2='221.21'
							gradientTransform='translate(-130.36 -193.02)'
							gradientUnits='userSpaceOnUse'
						>
							<stop offset='0' stopColor='#a1a1a0' />
							<stop offset='0.04' stopColor='#989897' />
							<stop offset='0.24' stopColor='#717171' />
							<stop offset='0.44' stopColor='#535352' />
							<stop offset='0.64' stopColor='#3d3d3d' />
							<stop offset='0.83' stopColor='#2f2f2f' />
							<stop offset='1' stopColor='#2b2b2b' />
						</linearGradient>
						<linearGradient
							id='linear-gradient-9'
							x1='183.63'
							y1='218.68'
							x2='183.63'
							y2='219.47'
							gradientTransform='translate(-130.36 -193.02)'
							gradientUnits='userSpaceOnUse'
						>
							<stop offset='0' stopColor='#ececec' />
							<stop offset='0.16' stopColor='#d1d1d1' />
							<stop offset='0.37' stopColor='#b6b6b6' />
							<stop offset='0.57' stopColor='#a3a3a2' />
							<stop offset='0.78' stopColor='#989897' />
							<stop offset='1' stopColor='#949493' />
						</linearGradient>
						<linearGradient
							id='linear-gradient-10'
							x1='27.2'
							y1='109.48'
							x2='78.46'
							y2='109.48'
							gradientUnits='userSpaceOnUse'
						>
							<stop offset='0' stopColor='#e8d594' />
							<stop offset='0.01' stopColor='#e8cf82' />
							<stop offset='0.04' stopColor='#e8c55f' />
							<stop offset='0.08' stopColor='#e8bd44' />
							<stop offset='0.11' stopColor='#e8b730' />
							<stop offset='0.14' stopColor='#e8b325' />
							<stop offset='0.17' stopColor='#e8b221' />
							<stop offset='0.35' stopColor='#e8dba7' />
							<stop offset='0.54' stopColor='#e7aa22' />
							<stop offset='0.62' stopColor='#e7831d' />
							<stop offset='0.7' stopColor='#984521' />
							<stop offset='0.83' stopColor='#e8a822' />
							<stop offset='0.87' stopColor='#e8ba53' />
							<stop offset='0.91' stopColor='#e7c87a' />
							<stop offset='0.95' stopColor='#e7d396' />
							<stop offset='0.98' stopColor='#e7d9a7' />
							<stop offset='1' stopColor='#e7dbad' />
						</linearGradient>
					</defs>
					<g id='Layer_2' data-name='Layer 2'>
						<g id='Layer_1-2' data-name='Layer 1'>
							<path
								d='M104.42.65c-5.1,6.85-11.57,17-14.63,24.53s-6.27,18.28-9.62,32.25L68.08,107.26l2,5.49L52.2,112.1l.18,4.52H81.1l-9.52-9.49-1.07-4.47L81.64,58.42q5-21,9.71-32.64C94.52,18,100.82,8,105.72,1.81Z'
								fill='#231f20'
							/>
							<path
								d='M1.3.65c5.11,6.85,11.57,17,14.63,24.53s6.27,18.28,9.62,32.25l12.09,49.83-2,5.49,17.83-.65-.18,4.52H24.62l9.52-9.49,1.07-4.47L24.08,58.42q-5-21-9.71-32.64C11.2,18,4.9,8,0,1.81Z'
								fill='#231f20'
							/>
							<path
								d='M67.83,113.25l0-27.49c-7.36-12.47-11.12-36.85-13-50.47a6.9,6.9,0,0,1,.77-4.85,4,4,0,0,0,.5-2.69A2.77,2.77,0,0,0,54,25.52a2.63,2.63,0,0,0-.55-.09v65A2.52,2.52,0,0,1,56.08,93a2.82,2.82,0,0,1-3,2.82,3,3,0,0,1-3-3.11c0-1.61,1.33-2.16,2.85-2.3l0-65c-1.55.14-2,1.44-2,3.09a1.85,1.85,0,0,0,.43,1.52c1,1.25.7,3.39.48,5-1.94,13.61-6,38-13.39,50.45l-.19,27.72,14.78,0Z'
								fill='#231f20'
							/>
							<g>
								<path
									d='M103.66,0A73.26,73.26,0,0,1,90.11,8.09,171.84,171.84,0,0,1,74,15.19,13.51,13.51,0,0,1,80.42,27q0,6.75-5.64,29.12l-3,11.94h0L69,79l-1.11,4.58,0-.12-2,8-8.1,17.06-1.45-.11-7.64,7H77.92L70,107.62l-1.28-5.49L79.84,57.82Q86,33.13,90.52,22.44c3-7.13,8-14.08,14-21.25Z'
									fill='#231f20'
								/>
								<path
									d='M104.66,0C102,2.3,97,4.78,91.46,7.65s-11,6-15.82,7.63c4.1,2.75,5.81,5.28,5.81,10.09q0,6.48-5.41,27.93L73.13,64.75h0L70.49,75.2l-1.06,4.18,0,.1-2,7.62-7.78,16.37-1.38-.11-9.11,12.2,28.7-.21L67.5,104.77l2.76-7.34L80.9,54.92Q86.81,31.24,91.14,21A83.73,83.73,0,0,1,104,.41Z'
									fill='url(#linear-gradient)'
								/>
								<path
									d='M103.66,0a74.42,74.42,0,0,1-13,8.29c-5.73,3-7.94,5.09-12.94,6.82,4,2.68,3.72,5.65,3.82,12.23.1,6.25-2.44,14.08-6.21,29l-3,11.94h0L69.53,79.16l-1.09,4.36,0,.1-2,7.95L58.3,108.63l-1.44-.11-7.64,7H78.46l-7.88-7.74-1.29-5.49L80.39,58q6.15-24.69,10.68-35.38C94.08,15.51,99,8.17,105,1Z'
									fill='url(#linear-gradient-2)'
								/>
							</g>
							<g>
								<path
									d='M2.14,0A73.06,73.06,0,0,0,15.7,8.1a173.58,173.58,0,0,0,16.1,7.11A13.48,13.48,0,0,0,25.38,27q0,6.75,5.65,29.11l3,11.94h0L36.82,79l1.1,4.36h0l2,8,8.11,17.06,1.44-.11,7.64,7H27.88l7.9-7.74,1.28-5.49L26,57.83Q19.81,33.14,15.28,22.45c-3-7.12-8-14.07-14-21.25Z'
									fill='#231f20'
								/>
								<path
									d='M1.15,0c2.7,2.29,7.7,4.77,13.19,7.65s11,6,15.83,7.63c-4.1,2.74-5.82,5.27-5.82,10.08q0,6.48,5.42,27.94l2.9,11.45h0l2.61,10.45,1,4.19,0,.08,2,7.63,7.77,16.36,1.38-.1,9.12,12.19-28.71-.2,10.39-10.63-2.72-7.3L24.9,54.93Q19,31.26,14.66,21A83.54,83.54,0,0,0,1.77.42Z'
									fill='url(#linear-gradient-3)'
								/>
								<path
									d='M2.14,0a74.42,74.42,0,0,0,13,8.29c5.73,3,8,5.08,13,6.81-4,2.69-3.73,5.65-3.83,12.23-.09,6.26,2.45,14.09,6.21,29l3,11.93h0l2.76,10.9,1.1,4.36,0,.1,2,8,8.1,17.06,1.45-.11,7.64,7H27.34l7.89-7.74,1.28-5.48L25.42,58Q19.25,33.35,14.74,22.66C11.72,15.53,6.76,8.19.82,1Z'
									fill='url(#linear-gradient-4)'
								/>
							</g>
							<polygon
								points='47.55 88.24 47.55 93.74 49.68 97.39 54.72 97.39 57.05 96.44 58.21 93.74 58.21 90.15 54.53 83.67 54.53 70.91 54.53 61.65 54.53 53.01 54.22 26.28 52.64 26.28 52.88 53.01 51.62 81.39 47.55 88.24'
								fill='#231f20'
							/>
							<path
								d='M67.35,113.25V86.52c-7-12.47-11.1-37.16-12.9-50.77a6.56,6.56,0,0,1,1.2-4.55,3.31,3.31,0,0,0,.48-2.68,3,3,0,0,0-2-2.24,1.29,1.29,0,0,0-.33,0l.09,64.15c1.45.15,2.19,1.52,2.19,3.14a2.86,2.86,0,1,1-5.7,0c0-1.61.82-2.88,2.27-3l.45-64.29a3,3,0,0,0-2.66,3.12,3.32,3.32,0,0,0,.64,2,6,6,0,0,1,1.11,4.44c-1.85,13.61-6.46,39.6-13.53,52.05l.41,25.46,14.12.74Z'
								fill='url(#linear-gradient-5)'
							/>
							<g opacity='0.9'>
								<path
									d='M67.34,114.66l-.08-27.07c-6.83-12.47-11-38.23-12.7-51.84a6.64,6.64,0,0,1,1.17-4.55,3.43,3.43,0,0,0,.46-2.68,3,3,0,0,0-2-2.24,2.18,2.18,0,0,0-.44,0l.12,64.25c1.41.14,2.22,1.42,2.22,3a2.79,2.79,0,1,1-5.55,0c0-1.61.65-2.88,2.06-3V26.28c-1.44.14-2,1.39-2,3a3.31,3.31,0,0,0,.62,2,6.19,6.19,0,0,1,1.08,4.44C50.54,49.35,46.82,75.85,39,88.24l0,25.75,14.12,1.54Z'
									fill='url(#linear-gradient-6)'
								/>
							</g>
							<path
								d='M54.21,34.21s1.63,37.43,13.13,53.46l.31-1.19S64,81.63,60.24,68.24C56.07,53.3,55.79,47.1,55.69,46.53c-.77-4.62-1-7.76-1-7.76l-.51-4.56Z'
								fill='#fff8de'
							/>
							<g>
								<path
									d='M56.29,27.66a2.25,2.25,0,0,1-1.6,2c-.42.17-.79,4-1.31,4s-.85-3.76-1.19-3.85a2.37,2.37,0,0,1-1.95-2.08c0-1.23,1.36-2.23,3-2.23S56.29,26.43,56.29,27.66Z'
									fill='url(#linear-gradient-7)'
								/>
								<path
									d='M55.3,27c0,.65-.91,1.18-2,1.18s-2-.53-2-1.18.91-1.18,2-1.18S55.3,26.33,55.3,27Z'
									fill='url(#linear-gradient-8)'
								/>
								<path
									d='M51.44,26.46s1.51-1.79,3.65,0A7.07,7.07,0,0,0,51.44,26.46Z'
									fill='url(#linear-gradient-9)'
								/>
							</g>
							<path
								d='M52.32,34.21s-2,37.81-14,54V87.15s3.58-5,7.57-18.49c4.46-15.12,4.76-21.39,4.87-22,.83-4.67,1-7.85,1-7.85l.55-4.62Z'
								fill='#fff8de'
							/>
							<path
								d='M53.8,38.82c0,.8.36,29.28.44,31.69,0,.93.07,1.87.09,2.8.05,2,.08,3.6.11,5.61,0,1.86,0,3.73,0,5.6s0,3.73,0,5.6l-.25-.38a3.7,3.7,0,0,1,1.44,1,3.54,3.54,0,0,1,.86,1.69,4.54,4.54,0,0,1,.08,1c0,.14,0,.32,0,.47a4,4,0,0,1-.07.48A3.21,3.21,0,0,1,55.63,96a2.82,2.82,0,0,1-1.48.76,3,3,0,0,1-2.9-1.13A3.22,3.22,0,0,1,50.63,94a3.15,3.15,0,0,0,.73,1.51,2.71,2.71,0,0,0,4,.08A2.75,2.75,0,0,0,56,94.18a2.57,2.57,0,0,0,0-.4c0-.13,0-.26,0-.41a4.06,4.06,0,0,0-.1-.79,2.69,2.69,0,0,0-.7-1.31A3.16,3.16,0,0,0,54,90.5l-.17-.11,0-.25c-.07-2-.13-3.78-.11-5.65s0-3.77,0-5.64,0-3.68,0-5.55c0-1,0-4,0-5S54,39.64,53.8,38.82Z'
								fill='#fff2c2'
							/>
							<path
								d='M78.46,115.56l-7.88-7.74-1-4.42-2.19,1.88c-3.49,2.39-7.51,4.81-14.55,4.81s-10.28-1.53-13.74-4l-2.82-2.63-1.15,4.32-7.89,7.74,22.62-.06h0c1.05,0,2.17,0,3.38,0,.95,0,1.83,0,2.67,0h0Z'
								opacity='0.6'
								fill='url(#linear-gradient-10)'
							/>
						</g>
					</g>
				</svg>
			</Link>
		);

	return (
		<Link
			to='/'
			onClick={() => (setLocation(LOCATIONS.HOME), window.scrollTo({ top: 0 }))}
		>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				xmlnsXlink='http://www.w3.org/1999/xlink'
				viewBox='0 0 246.35 131.78'
				preserveAspectRatio='xMidYMid meet'
				id='svg-logo'
				className={className}
			>
				<defs>
					<linearGradient
						id='linear-gradient-logo'
						x1='49.22'
						y1='62.83'
						x2='104.66'
						y2='62.83'
						gradientTransform='matrix(1, 0, 0, -1, 0, 131.93)'
						gradientUnits='userSpaceOnUse'
					>
						<stop offset='0' stopColor='#fff1c1' />
						<stop offset='0.01' stopColor='#ffeeb3' />
						<stop offset='0.04' stopColor='#ffe690' />
						<stop offset='0.07' stopColor='#ffdf75' />
						<stop offset='0.11' stopColor='#ffdb61' />
						<stop offset='0.14' stopColor='#ffd856' />
						<stop offset='0.17' stopColor='#ffd752' />
						<stop offset='0.35' stopColor='#fff4d0' />
						<stop offset='0.57' stopColor='#f0b61b' />
						<stop offset='0.7' stopColor='#ce832d' />
						<stop offset='0.83' stopColor='#ffd547' />
						<stop offset='0.83' stopColor='#ffd548' />
						<stop offset='0.87' stopColor='#ffe079' />
						<stop offset='0.91' stopColor='#ffe9a0' />
						<stop offset='0.95' stopColor='#fff0bc' />
						<stop offset='0.98' stopColor='#fff4cd' />
						<stop offset='1' stopColor='#fff5d3' />
					</linearGradient>
					<linearGradient
						id='linear-gradient-logo-2'
						x1='49.22'
						y1='62.84'
						x2='104.99'
						y2='62.84'
						gradientTransform='matrix(1, 0, 0, -1, 0, 131.93)'
						gradientUnits='userSpaceOnUse'
					>
						<stop offset='0' stopColor='#fff7e7' />
						<stop offset='0.01' stopColor='#fff6e1' />
						<stop offset='0.04' stopColor='#ffefbe' />
						<stop offset='0.07' stopColor='#ffeaa3' />
						<stop offset='0.1' stopColor='#ffe78f' />
						<stop offset='0.14' stopColor='#ffe584' />
						<stop offset='0.17' stopColor='#ffe480' />
						<stop offset='0.35' stopColor='#fff5da' />
						<stop offset='0.43' stopColor='#ffe17c' />
						<stop offset='0.54' stopColor='#fbd93f' />
						<stop offset='0.63' stopColor='#e7831d' />
						<stop offset='0.7' stopColor='#cf902c' />
						<stop offset='0.83' stopColor='#fcd92b' />
						<stop offset='0.86' stopColor='#fde052' />
						<stop offset='0.89' stopColor='#fde883' />
						<stop offset='0.92' stopColor='#feeeaa' />
						<stop offset='0.95' stopColor='#fff3c6' />
						<stop offset='0.98' stopColor='#fff6d7' />
						<stop offset='1' stopColor='#fff7dd' />
					</linearGradient>
					<linearGradient
						id='linear-gradient-logo-3'
						x1='349.17'
						y1='62.81'
						x2='404.57'
						y2='62.81'
						gradientTransform='translate(405.72 131.93) rotate(180)'
						xlinkHref='#linear-gradient-logo'
					/>
					<linearGradient
						id='linear-gradient-logo-4'
						x1='349.13'
						y1='62.8'
						x2='404.9'
						y2='62.8'
						gradientTransform='translate(405.72 131.93) rotate(180)'
						xlinkHref='#linear-gradient-logo-2'
					/>
					<linearGradient
						id='linear-gradient-logo-5'
						x1='40.76'
						y1='50.26'
						x2='70.81'
						y2='50.26'
						gradientTransform='matrix(0.96, 0, 0, -1, -0.34, 131.76)'
						gradientUnits='userSpaceOnUse'
					>
						<stop offset='0' stopColor='#ffeeb4' />
						<stop offset='0.03' stopColor='#ffe68e' />
						<stop offset='0.05' stopColor='#ffde6b' />
						<stop offset='0.08' stopColor='#ffd850' />
						<stop offset='0.11' stopColor='#ffd33c' />
						<stop offset='0.14' stopColor='#ffd131' />
						<stop offset='0.17' stopColor='#ffd02d' />
						<stop offset='0.35' stopColor='#fff2c6' />
						<stop offset='0.54' stopColor='#ffc80d' />
						<stop offset='0.7' stopColor='#b66528' />
						<stop offset='0.83' stopColor='#ffc608' />
						<stop offset='0.87' stopColor='#ffd340' />
						<stop offset='0.9' stopColor='#ffdf71' />
						<stop offset='0.93' stopColor='#ffe898' />
						<stop offset='0.96' stopColor='#ffefb4' />
						<stop offset='0.98' stopColor='#fff3c5' />
						<stop offset='1' stopColor='#fff4cb' />
					</linearGradient>
					<linearGradient
						id='linear-gradient-logo-6'
						x1='40.75'
						y1='49.94'
						x2='71.22'
						y2='49.94'
						gradientTransform='matrix(0.93, 0, 0, -1, 1.17, 132.16)'
						xlinkHref='#linear-gradient-logo-2'
					/>
					<linearGradient
						id='linear-gradient-logo-7'
						x1='183.63'
						y1='-97.73'
						x2='183.63'
						y2='-106.07'
						gradientTransform='matrix(1, 0, 0, -1, -130.36, -61.09)'
						gradientUnits='userSpaceOnUse'
					>
						<stop offset='0' stopColor='#2b2b2b' />
						<stop offset='0.1' stopColor='#232323' />
						<stop offset='0.39' stopColor='#0f0f0f' />
						<stop offset='0.69' stopColor='#040404' />
						<stop offset='1' />
					</linearGradient>
					<linearGradient
						id='linear-gradient-logo-8'
						x1='183.66'
						y1='-98.1'
						x2='183.66'
						y2='-100.6'
						gradientTransform='matrix(1, 0, 0, -1, -130.36, -61.09)'
						gradientUnits='userSpaceOnUse'
					>
						<stop offset='0' stopColor='#a0a09f' />
						<stop offset='0.04' stopColor='#989897' />
						<stop offset='0.24' stopColor='#717171' />
						<stop offset='0.44' stopColor='#535352' />
						<stop offset='0.64' stopColor='#3d3d3d' />
						<stop offset='0.83' stopColor='#2f2f2f' />
						<stop offset='1' stopColor='#2b2b2b' />
					</linearGradient>
					<linearGradient
						id='linear-gradient-logo-9'
						x1='183.63'
						y1='-98.07'
						x2='183.63'
						y2='-98.87'
						gradientTransform='matrix(1, 0, 0, -1, -130.36, -61.09)'
						gradientUnits='userSpaceOnUse'
					>
						<stop offset='0' stopColor='#ebebeb' />
						<stop offset='0.16' stopColor='#d0d0d0' />
						<stop offset='0.37' stopColor='#b5b5b5' />
						<stop offset='0.57' stopColor='#a2a2a1' />
						<stop offset='0.78' stopColor='#979796' />
						<stop offset='1' stopColor='#939392' />
					</linearGradient>
					<linearGradient
						id='linear-gradient-logo-10'
						x1='27.24'
						y1='11.13'
						x2='78.46'
						y2='11.13'
						gradientTransform='matrix(1, 0, 0, -1, 0, 131.93)'
						gradientUnits='userSpaceOnUse'
					>
						<stop offset='0' stopColor='#e7d493' />
						<stop offset='0.01' stopColor='#e7cf82' />
						<stop offset='0.04' stopColor='#e7c45f' />
						<stop offset='0.08' stopColor='#e7bc44' />
						<stop offset='0.11' stopColor='#e7b630' />
						<stop offset='0.14' stopColor='#e7b225' />
						<stop offset='0.17' stopColor='#e7b121' />
						<stop offset='0.35' stopColor='#e7daa6' />
						<stop offset='0.54' stopColor='#e6a922' />
						<stop offset='0.62' stopColor='#e7831d' />
						<stop offset='0.7' stopColor='#974521' />
						<stop offset='0.83' stopColor='#e7a722' />
						<stop offset='0.87' stopColor='#e7b952' />
						<stop offset='0.91' stopColor='#e6c779' />
						<stop offset='0.95' stopColor='#e6d295' />
						<stop offset='0.98' stopColor='#e6d8a6' />
						<stop offset='1' stopColor='#e6daac' />
					</linearGradient>
				</defs>

				<g id='logo' className='logo'>
					<g id='logo-w'>
						<path
							d='M104.42,12c-5.1,6.84-11.57,17-14.63,24.53S83.52,54.82,80.17,68.8L68.08,118.59l2,5.48-17.83-.64.18,4.51H81.1l-9.52-9.48L70.51,114,81.64,69.74q5-21,9.71-32.64c3.17-7.78,9.47-17.77,14.37-24Z'
							style={{ fill: '#231f20' }}
						/>
						<path
							d='M1.3,12c5.11,6.8,11.57,17,14.63,24.49s6.27,18.27,9.62,32.25l12.09,49.83-2,5.48,17.83-.64-.18,4.51H24.62l9.52-9.48L35.21,114,24.08,69.74q-5-21-9.71-32.64C11.2,29.32,4.9,19.33,0,13.14Z'
							style={{ fill: '#231f20' }}
						/>
						<path
							d='M67.83,124.58V97.09c-7.36-12.48-11.12-36.86-13-50.47a6.92,6.92,0,0,1,.77-4.86,3.94,3.94,0,0,0,.5-2.68A2.8,2.8,0,0,0,54,36.84a2,2,0,0,0-.55-.08v65a2.53,2.53,0,0,1,2.61,2.45v.14a2.81,2.81,0,0,1-2.81,2.82h-.19a3,3,0,0,1-3-3v-.1c0-1.62,1.33-2.17,2.85-2.31v-65c-1.55.14-2,1.44-2,3.09a1.89,1.89,0,0,0,.43,1.53c1,1.24.7,3.39.48,5-1.94,13.6-6,38-13.39,50.45l-.19,27.72H53Z'
							style={{ fill: '#231f20' }}
						/>
						<path
							d='M103.66,11.32a72.79,72.79,0,0,1-13.55,8.09A175,175,0,0,1,74,26.52a13.49,13.49,0,0,1,6.41,11.82q0,6.75-5.64,29.11l-3,11.94h0L69,90.29l-1.11,4.58v-.13l-2,8-8.1,17.06-1.45-.11-7.64,7H77.92L70,118.94l-1.28-5.48L79.84,69.14Q86,44.45,90.52,33.76c3-7.12,8-14.07,14-21.25Z'
							style={{ fill: '#231f20' }}
						/>
						<path
							d='M104.66,11.32C102,13.62,97,16.1,91.46,19s-11,6-15.82,7.63c4.1,2.74,5.81,5.27,5.81,10.09q0,6.46-5.41,27.93L73.13,76.08h0L70.49,86.53l-1.06,4.18v.09l-2,7.63-7.78,16.36-1.38-.1-9.11,12.19,28.7-.2L67.5,116.1l2.76-7.35L80.9,66.25q5.91-23.7,10.24-33.94A83.68,83.68,0,0,1,104,11.73Z'
							style={{ fill: 'url(#linear-gradient-logo)' }}
						/>
						<path
							d='M103.66,11.32a74.26,74.26,0,0,1-13,8.3c-5.73,3-7.94,5.08-12.94,6.82,4,2.68,3.72,5.64,3.82,12.22.1,6.26-2.44,14.09-6.21,29l-3,11.93h0l-2.8,10.9-1.09,4.36V95l-2,8L58.3,120l-1.44-.11-7.64,7H78.46l-7.88-7.73-1.29-5.49,11.1-44.31Q86.54,44.66,91.07,34c3-7.13,8-14.47,13.92-21.65Z'
							style={{ fill: 'url(#linear-gradient-logo-2)' }}
						/>
						<path
							d='M2.14,11.34A72.87,72.87,0,0,0,15.7,19.43a171,171,0,0,0,16.1,7.1,13.48,13.48,0,0,0-6.42,11.82q0,6.75,5.65,29.12L34,79.4h0L36.8,90.29l1.1,4.36h0l2,8L48,119.71l1.44-.11,7.64,7H27.88l7.9-7.73,1.28-5.49L26,69.16Q19.81,44.47,15.28,33.78c-3-7.13-8-14.08-14-21.25Z'
							style={{ fill: '#231f20' }}
						/>
						<path
							d='M1.15,11.34c2.7,2.29,7.7,4.78,13.19,7.65s11,6,15.83,7.63c-4.1,2.75-5.82,5.28-5.82,10.09q0,6.48,5.42,27.93l2.9,11.45h0l2.61,10.46,1,4.18v.09l2,7.62,7.77,16.37,1.38-.11,9.12,12.2-28.71-.21,10.39-10.62-2.72-7.3L24.9,66.26Q19,42.58,14.66,32.32A84.08,84.08,0,0,0,1.77,11.74Z'
							style={{ fill: 'url(#linear-gradient-logo-3)' }}
						/>
						<path
							d='M2.14,11.34a74.8,74.8,0,0,0,13,8.29c5.73,3,8,5.08,13,6.82-4,2.68-3.73,5.65-3.83,12.22-.09,6.26,2.45,14.09,6.21,29l3,11.94h0L36.28,90.5l1.1,4.36V95l2,8L47.5,120l1.45-.11,7.64,7H27.34l7.89-7.74,1.28-5.49L25.42,69.36Q19.25,44.67,14.74,34c-3-7.13-8-14.47-13.92-21.64Z'
							style={{ fill: 'url(#linear-gradient-logo-4)' }}
						/>
						<polygon
							points='47.55 99.57 47.55 105.07 49.68 108.71 54.72 108.71 57.05 107.76 58.21 105.07 58.21 101.47 54.53 95 54.53 82.24 54.53 72.98 54.53 64.33 54.22 37.6 52.64 37.6 52.88 64.33 51.62 92.71 47.55 99.57'
							style={{ fill: '#231f20' }}
						/>
						<path
							d='M67.35,124.58V97.85c-7-12.48-11.1-37.16-12.9-50.77a6.56,6.56,0,0,1,1.2-4.56,3.3,3.3,0,0,0,.48-2.68,3,3,0,0,0-2-2.24.92.92,0,0,0-.33,0l.09,64.16c1.45.14,2.19,1.51,2.19,3.13a2.86,2.86,0,1,1-5.7.48,3.84,3.84,0,0,1,0-.48c0-1.62.82-2.88,2.27-3l.45-64.3a3,3,0,0,0-2.66,3.12,3.34,3.34,0,0,0,.64,2,6,6,0,0,1,1.11,4.44c-1.85,13.6-6.46,39.59-13.53,52.05l.41,25.46,14.12.74Z'
							style={{ fill: 'url(#linear-gradient-logo-5)' }}
						/>
						<path
							d='M67.34,126l-.08-27.1c-6.83-12.48-11-38.23-12.7-51.85a6.68,6.68,0,0,1,1.17-4.55,3.42,3.42,0,0,0,.46-2.68,3,3,0,0,0-2-2.24,1.62,1.62,0,0,0-.44,0l.12,64.26c1.41.14,2.22,1.41,2.22,3a2.79,2.79,0,1,1-5.55,0c0-1.62.65-2.88,2.06-3V37.6c-1.44.14-2,1.39-2,3a3.34,3.34,0,0,0,.62,2A6.14,6.14,0,0,1,52.3,47C50.54,60.67,46.82,87.18,39,99.56v25.76l14.12,1.53Z'
							style={{ fill: 'url(#linear-gradient-logo-6)' }}
						/>
						<path
							d='M54.21,45.53S55.84,83,67.34,99l.31-1.19S64,93,60.24,79.57c-4.17-14.94-4.45-21.14-4.55-21.72-.77-4.61-1-7.76-1-7.76l-.51-4.56Z'
							style={{ fill: '#fff7dd' }}
						/>
						<path
							d='M56.29,39a2.25,2.25,0,0,1-1.6,2c-.42.17-.79,4-1.31,4s-.85-3.77-1.19-3.86A2.38,2.38,0,0,1,50.24,39c0-1.23,1.36-2.22,3-2.22S56.29,37.75,56.29,39Z'
							style={{ fill: 'url(#linear-gradient-logo-7)' }}
						/>
						<path
							d='M55.3,38.3c0,.66-.91,1.19-2,1.19s-2-.53-2-1.19.91-1.18,2-1.18S55.3,37.65,55.3,38.3Z'
							style={{ fill: 'url(#linear-gradient-logo-8)' }}
						/>
						<path
							d='M51.44,37.78a2.47,2.47,0,0,1,3.5-.15l.15.15A7.06,7.06,0,0,0,51.44,37.78Z'
							style={{ fill: 'url(#linear-gradient-logo-9)' }}
						/>
						<path
							d='M52.32,45.54s-2,37.81-14,54V98.47S41.87,93.53,45.86,80c4.46-15.12,4.76-21.39,4.87-22a71.83,71.83,0,0,0,1-7.86l.55-4.61Z'
							style={{ fill: '#fff7dd' }}
						/>
						<path
							d='M53.8,50.14c0,.8.36,29.28.44,31.7,0,.93.07,1.86.09,2.8.05,2,.08,3.6.11,5.6s0,3.74,0,5.6v5.61l-.25-.39a3.74,3.74,0,0,1,2.3,2.69,4.77,4.77,0,0,1,.08,1v.47a3.81,3.81,0,0,1-.07.47,3.18,3.18,0,0,1-.86,1.65,2.79,2.79,0,0,1-1.48.77,3,3,0,0,1-2.9-1.14,3.23,3.23,0,0,1-.62-1.62,3.1,3.1,0,0,0,.73,1.51,2.74,2.74,0,0,0,1.28.8,2.67,2.67,0,0,0,2.68-.72,2.82,2.82,0,0,0,.64-1.39,2.67,2.67,0,0,0,0-.4v-.42a4.17,4.17,0,0,0-.1-.79,2.71,2.71,0,0,0-.7-1.3,3,3,0,0,0-1.19-.77l-.17-.11v-.25c-.07-2-.13-3.79-.11-5.66s0-3.76,0-5.63V79.66C53.7,78.66,54,51,53.8,50.14Z'
							style={{ fill: '#fff1c1' }}
						/>
						<path
							d='M78.46,126.88l-7.88-7.73-1-4.43-2.19,1.88c-3.49,2.4-7.51,4.81-14.55,4.81s-10.28-1.53-13.74-4l-2.82-2.62-1.15,4.32-7.89,7.73H55.91Z'
							style={{
								opacity: '0.6000000238418579',
								isolation: 'isolate',
								fill: 'url(#linear-gradient-logo-10)',
							}}
						/>
					</g>
					<g id='logo-type' ref={typeRef}>
						<path d='M97.28,102.3v.24a.91.91,0,0,1-.17.34h0A63.49,63.49,0,0,1,88,111.8q-4.32,3.33-6.63,3a2.52,2.52,0,0,1-2.13-1.9,12.37,12.37,0,0,1,.34-6.39c.2-.72.41-1.38.65-2s.37-1,.56-1.45a31.92,31.92,0,0,1,2.13-4l.13-.25h0c.38-.58.76-1.12,1.12-1.63Q88,92,89.83,93.24a2.21,2.21,0,0,1,.65,1.06A3.62,3.62,0,0,1,90.54,96a5.33,5.33,0,0,1-1,2.22A9.25,9.25,0,0,1,87.66,100a22.66,22.66,0,0,1-4.31,2.39,1.92,1.92,0,0,0-.7.53,5.77,5.77,0,0,0-1,1.4h0l-.09.21a15.53,15.53,0,0,0-1.44,5,4.36,4.36,0,0,0,.76,2.82,2.31,2.31,0,0,0,1.83.91c1.4,0,3.35-1,5.85-2.86a71.74,71.74,0,0,0,8.53-8C97.18,102.2,97.24,102.2,97.28,102.3Zm-13.77-1.15a1.07,1.07,0,0,0-.2.38c0,.1,0,.12.18.07a20.65,20.65,0,0,0,2.57-1.41,7.75,7.75,0,0,0,2.61-2.45c.24-.39,1.23-2.54,0-2.06C86.08,96.66,85,99,83.51,101.15Z' />
						<path d='M115.59,99.58h.14a.31.31,0,0,1,0,.19.39.39,0,0,1-.16.2c-.91.62-2,1.39-3.27,2.3a3,3,0,0,0-.81.85,2.64,2.64,0,0,0-.25.66h0a5.28,5.28,0,0,1-.31,1c-.15.46-.31.92-.46,1.34a46.61,46.61,0,0,1-9.77,15.49,32.73,32.73,0,0,1-5.23,4.45,8.65,8.65,0,0,1-4.12,1.71h0a1.65,1.65,0,0,1-1-.34,1.62,1.62,0,0,1-.47-.74,3.49,3.49,0,0,1-.11-.78c-.06-1.47.85-3.47,2.71-6a41.27,41.27,0,0,1,3.47-4q2.07-2.16,4.8-4.79a83.71,83.71,0,0,1,8.48-7.26,2,2,0,0,0,.53-.55,1.72,1.72,0,0,0,.19-.47,13.18,13.18,0,0,0,.33-2.5,2.63,2.63,0,0,0-.37-1.73c-.46-.47-1.32-.4-2.58.2a19,19,0,0,0-4.71,3.66,54.32,54.32,0,0,0-6.22,7.72l-.25.27a.88.88,0,0,1-.41.2c-.15,0-.27-.07-.37-.29a4,4,0,0,1-.06-2.09,26.82,26.82,0,0,1,1.08-4q2.14-6.39,7.83-19.23h0q5.53-12,8.94-18.2c1-1.79,1.75-3.09,2.32-3.92a8.1,8.1,0,0,1,1.31-1.6q.45-.35.69-.27.61.06.72,1.11a16,16,0,0,1-1.21,5c-.81,2.24-1.66,4.39-2.56,6.43S113,77,112.69,77.51Q111,81.1,108,86.39t-7.14,11.07h0c-.15.2-.38.54-.71,1a13.18,13.18,0,0,0-1,1.66l-.48,1a.75.75,0,0,1-.07.12c-.93,2.24-1.6,4-2,5.11a7.31,7.31,0,0,0-.56,2.4.33.33,0,0,0,0,.14.07.07,0,0,0,.1,0,1.15,1.15,0,0,0,.22-.22,72.35,72.35,0,0,1,5.89-7.07,24.7,24.7,0,0,1,5.24-4.38c1.54-.89,2.7-1,3.46-.27a2.9,2.9,0,0,1,.73,1.41,8.17,8.17,0,0,1,.07,3v.41s.12,0,.22-.06a.26.26,0,0,1,.11-.07h0C113.46,100.92,114.63,100.17,115.59,99.58ZM109.26,105a.79.79,0,0,0,.07-.37c0-.06,0-.08-.11-.07a.57.57,0,0,0-.18.12q-3.69,2.88-8.14,7.14a87,87,0,0,0-6.5,6.94,27.81,27.81,0,0,0-3.09,4.37,4.75,4.75,0,0,0-.73,2.19c.19.93.79,1.27,1.81,1a11,11,0,0,0,3.8-2.23,37.55,37.55,0,0,0,4.77-4.75,49.09,49.09,0,0,0,4.69-6.58A41.14,41.14,0,0,0,109.26,105Zm-9-7.74-.06.18a.64.64,0,0,0-.06.18.2.2,0,0,0,0,.11h.09a1.81,1.81,0,0,0,.25-.3A121.63,121.63,0,0,0,108.1,85a133.4,133.4,0,0,0,6-12.54c1.58-3.84,2.42-6.58,2.52-8.2-.69,1-2,3.26-3.94,6.81S108.19,79.8,105,86.6q-2.87,6.42-4.74,10.72Z' />
						<path d='M152.31,101.51c.22.31,0,.78-.2,1a1,1,0,0,0-.35.78c-.22.3-.34.52-.38.56a1.9,1.9,0,0,0-.34.54,8,8,0,0,1-.5,1.16c-.48.71-1,1.41-1.49,2.08a17.89,17.89,0,0,1-1.73,1.86l-1.44,1.33q-4.14,4-6.25,2.12c-.92-.88-1.45-2.39-1.6-4.55a28.5,28.5,0,0,1,.74-7.87c.12-.53.26-1.08.4-1.62a22.06,22.06,0,0,0,.54-2.54c0-.28,0-.44-.09-.47a.36.36,0,0,0-.33.1,4,4,0,0,0-.38.34,54.86,54.86,0,0,0-3.82,5.61q-2.33,3.77-4.35,7.22c-1.34,2.29-2.22,3.72-2.63,4.31a4.07,4.07,0,0,1-1.05,1.14c-.36.25-.62.26-.77,0s-.1-.79.15-1.71c0-.09.3-1,.83-2.56s.88-2.55,2.25-5.81c1.19-2.84,2.4-4.78,1.37-7.25-.2-.49,1.23-2.14,1.5-2.25a1.76,1.76,0,0,1,1.25.21,2.75,2.75,0,0,1,.66,1.33,5.63,5.63,0,0,1-.6,2.93c-.27.65-1.07,1.86-1.95,3.66q-1.59,3.33-3.2,7.06c-.11.28-.2.54-.29.79a2.94,2.94,0,0,0-.16.58c0,.15,0,.17.13.09a3.56,3.56,0,0,0,.58-.76c.82-1.34,1.82-3,3-5s2.52-4.24,3.83-6.36,2.47-3.88,3.49-5.26,1.74-2,2.15-1.82c.65.33.92,1.09.82,2.26a39.82,39.82,0,0,1-1.4,6.07,36.16,36.16,0,0,0-1,5,19.69,19.69,0,0,0-.12,4.34c.12,1.21.47,1.92,1,2.13,1.3.31,2.76-.2,4.39-1.51a34.43,34.43,0,0,0,5-5.24c.4-.51.43-1.21.81-1.75s.23-.84.44-1.29c.12-.24.45-1,.8-1S152.25,101.42,152.31,101.51Z' />
						<path d='M192.73,106.39c.06,0,.09,0,.11.13a.37.37,0,0,1-.1.28q-5.67,8.79-9.32,13.78a63.76,63.76,0,0,1-5.74,7.07c-1.39,1.38-2.4,2.07-3,2.06a1.19,1.19,0,0,1-1-.33q-2-1.86,1.38-13.17t11.52-32.53a1,1,0,0,1,.1-.28c0-.09.19-.47.27-.71L188,79.75c1.23-3.43,2.32-6.34,3.24-8.75A79.83,79.83,0,0,0,194,62.75a.85.85,0,0,1,0-.5,2.24,2.24,0,0,1,.28-.76,1.28,1.28,0,0,1,.58-.57.82.82,0,0,1,.65,0,.85.85,0,0,1,.44.49,3.06,3.06,0,0,1-.14,2c-.27.88-.79,2.27-1.56,4.18q-.7,1.74-1.68,4.32c-.2.54-.7,1.81-1.48,3.82s-1.62,4.17-2.68,6.88q-3.39,8.77-6.55,17.16t-4.52,12.43c-.75,2.33-1.37,4.34-1.83,6s-.83,3.09-1.08,4.22a26.55,26.55,0,0,0-.47,2.76,10.79,10.79,0,0,0-.06,1.61,2.49,2.49,0,0,0,.17.8,1,1,0,0,0,.18.31h0c.59.54,1.6.16,3-1.14a45.22,45.22,0,0,0,4.93-5.51q2.79-3.57,5.54-7.55t4.84-7.23A.17.17,0,0,1,192.73,106.39Z' />
						<path d='M213.28,98.91a.19.19,0,0,1,.16.06.39.39,0,0,1,0,.3,2.5,2.5,0,0,1-.27.63q-4.14,6.69-7.38,11.17c-2.15,3-3.83,4.55-5,4.75a1.93,1.93,0,0,1-1.63-.64q-1.86-2.19-1.28-8.62a6,6,0,0,0,0-.85c0-.16,0-.24-.09-.23s-.1,0-.16.14a2.1,2.1,0,0,0-.15.3c-.53,1.11-1,2-1.41,2.81a22.43,22.43,0,0,1-1.26,2.1,10.77,10.77,0,0,1-2.09,2.33c-.68.52-1.26.61-1.72.28a1.91,1.91,0,0,1-.53-1.59,11.19,11.19,0,0,1,.33-2.31c.2-.8.38-1.46.53-2a.18.18,0,0,0,0-.07,77.22,77.22,0,0,1,2.88-7.78A36.24,36.24,0,0,1,197,94.2c.88-1.41,1.7-1.83,2.44-1.27a2.75,2.75,0,0,1,.72,1.58,12,12,0,0,1,.14,2.39,1,1,0,0,0,0,.35.42.42,0,0,0,.16.27,1.19,1.19,0,0,1,.26.91,9.5,9.5,0,0,1-.17,1.29h0a77.25,77.25,0,0,0-1.28,9.71c-.07,2.09,0,3.37.32,3.81.38.9,1.09,1.07,2.13.53s2.49-2,4.35-4.37,4.22-5.86,7.09-10.42A.23.23,0,0,1,213.28,98.91Zm-15.55,2.53c.15-.64.28-1.29.38-2a2.5,2.5,0,0,0,0-1.33h0c-.35,0-.91.63-1.69,2a48.55,48.55,0,0,0-2.39,4.72,40,40,0,0,0-1.88,4.84.24.24,0,0,0,0,.12c-.07.23-.16.53-.26.92a2.8,2.8,0,0,0-.1,1c0,.27.19.36.49.26a6.76,6.76,0,0,0,2.5-2.48,28.12,28.12,0,0,0,2.64-4.85,2.92,2.92,0,0,0,.27-1.3h0A10,10,0,0,1,197.73,101.44Z' />
						<path d='M246.12,90.41c.08,0,.13-.06.17,0a.2.2,0,0,1,.06.18v.32l-.11.16-.14.11c-.77.69-2.14,2.08-4.13,4.17L236.51,101a13.9,13.9,0,0,1,1.06,3.91,19,19,0,0,1-.07,5,22.92,22.92,0,0,1-6.07,12.24v.07h-.06c-.35.32-.72.66-1.12,1h0a10.75,10.75,0,0,1-3.94,2.11,3,3,0,0,1-1.19-.13,2.25,2.25,0,0,1-1.5-1.72,8.5,8.5,0,0,1,.1-3.82,27.44,27.44,0,0,1,3.94-9.34,48.83,48.83,0,0,1,6.47-8,.38.38,0,0,0,.11-.11l.11-.07v-.07h.06l.09-.08a1,1,0,0,0,.24-.48.4.4,0,0,0-.12-.33,6.24,6.24,0,0,0-2.16-1.76c-.16-.1-.33-.18-.49-.26a13.55,13.55,0,0,1-4.49-2.63.5.5,0,0,0-.7-.1l-.1.1c-1.85,2.08-3.45,4-4.78,5.78s-2.48,3.39-3.45,4.83l-.63.86a1.4,1.4,0,0,0-.22.44.58.58,0,0,0,0,.32,1.87,1.87,0,0,0,.07.22h0a5.81,5.81,0,0,1,.74,3,11.73,11.73,0,0,1-.82,4.26.36.36,0,0,1-.09.24,2.17,2.17,0,0,1-.15.35,6.46,6.46,0,0,1-1.77,2.49,2.09,2.09,0,0,1-1.59.5h-.12a1.42,1.42,0,0,1-.64-.44,2.15,2.15,0,0,1-.37-.66,2.72,2.72,0,0,1-.15-.54v-.13a5.6,5.6,0,0,1,0-2h0a7.54,7.54,0,0,1,.2-.82,11.21,11.21,0,0,1,.61-1.71,12.2,12.2,0,0,1,.58-1.14v-.14c.34-.63.6-1.11.79-1.44a1,1,0,0,0,.08-.14l.39-.64a2.63,2.63,0,0,0,.29-.64,1,1,0,0,0,0-.42.79.79,0,0,0-.08-.26l-.32-.58c-.29-.54-.63-1.2-1-2l-.83-1.64a13.52,13.52,0,0,1-1.29-8.7q1.05-5.37,6.5-9.49a.65.65,0,0,1,.83-.07,1.49,1.49,0,0,1,.5,1A6.56,6.56,0,0,1,220,89a2,2,0,0,1-.53,1.35,34.09,34.09,0,0,0-3.67,3.13,7.45,7.45,0,0,0-2,3.08,8.84,8.84,0,0,0-.19,3.62,12.47,12.47,0,0,0,.82,3q.38.9.84,1.77l.07.16c.4.79.77,1.45,1.1,2s.53.53.77.24c.11-.14.21-.28.31-.43,1.06-1.47,2.3-3.11,3.7-4.92s3.08-3.78,5-5.93a2.71,2.71,0,0,0,.21-.37.71.71,0,0,0,0-.29.65.65,0,0,0,0-.2h0a6,6,0,0,1-.5-3.17,6.81,6.81,0,0,1,1.58-3.77,11.89,11.89,0,0,1,2.84-2.45,14.57,14.57,0,0,1,2.31-1.22.8.8,0,0,1,.89.18A1.6,1.6,0,0,1,234,86a5.53,5.53,0,0,1-.36,2.48c-.27.54-.54.84-.82.91a9.69,9.69,0,0,0-3.57,1.49,2.22,2.22,0,0,0-1.1,1.75,1.91,1.91,0,0,0,.13.51,2,2,0,0,0,.39.65h.06a2.77,2.77,0,0,0,.47.5h0a21.14,21.14,0,0,0,4.09,2.86,6.25,6.25,0,0,1,1.48,1.18,11.62,11.62,0,0,1,1.09,1.42c.1.17.2.34.29.51a1.07,1.07,0,0,0,.18-.19l.14-.14a.67.67,0,0,0,.27-.23h0l0-.07c.91-.93,1.82-1.85,2.72-2.78.5-.53,1-1,1.48-1.53C243.24,93.18,244.94,91.52,246.12,90.41Zm-31.84,27.7c.44,0,.86-.34,1.26-1a10.36,10.36,0,0,0,1-2.44,7.64,7.64,0,0,0,.29-2.28,7.47,7.47,0,0,0-.3-1.48c-.07-.22-.14-.32-.22-.29a.41.41,0,0,0-.21.22c-.47.76-.85,1.4-1.13,1.94v.07h0V113l-.05.07-.08.17-.06.14h0a10,10,0,0,0-.78,2.41,4.75,4.75,0,0,0-.13,1.55A.79.79,0,0,0,214.28,118.11Zm22.09-8.48a13.16,13.16,0,0,0,.09-3.76,10.83,10.83,0,0,0-.8-3c-.11-.23-.23-.34-.34-.32a.63.63,0,0,0-.32.15l-.44.47h-.07a41.87,41.87,0,0,0-7.29,9.4,17.81,17.81,0,0,0-2.62,9.26c.19,1.37.83,1.94,1.9,1.72a8.33,8.33,0,0,0,3.71-2.36,23.48,23.48,0,0,0,3.85-5.07,19.54,19.54,0,0,0,2.34-6.41A.19.19,0,0,0,236.37,109.63Z' />
						<path d='M184.24,91.53a.65.65,0,0,1,.09.43,1.06,1.06,0,0,1-.17.57q-7.36,12.12-13.37,20.77a103.09,103.09,0,0,1-10.52,13.22q-5,5-8,5.25a3.48,3.48,0,0,1-3.53-2.25,14,14,0,0,1-1.16-5.68,47.44,47.44,0,0,1,.47-7.44c.37-2.67.85-5.29,1.42-7.85s1.15-4.86,1.72-6.88a197.24,197.24,0,0,1,15-38.1,97.62,97.62,0,0,1,8.08-13.32q3.15-4,4.94-4.49a2,2,0,0,1,2.58,1.08c.59,1.08.66,3.19.19,6.33a96.19,96.19,0,0,1-2.38,11q-1.71,6.3-3.93,12.69a1.53,1.53,0,0,0-.11.48q0,.09.18-.27c.87-1.68,1.84-3.44,2.89-5.29s2-3.44,2.9-4.75,1.45-2,1.74-1.93a1,1,0,0,1,.58.69,2.6,2.6,0,0,1,0,1.24c-.18.83-.49,1.25-.94,1.24a20.41,20.41,0,0,0-3.13,3.62,64.68,64.68,0,0,0-4.6,7.21,3.87,3.87,0,0,1-.27.43.66.66,0,0,1-.19.18h-.08q-.18,0-.21-.21a1.77,1.77,0,0,1,0-.46,11.05,11.05,0,0,1,.4-1.5c.19-.59.4-1.2.62-1.83a3.52,3.52,0,0,0,.15-.42l.57-1.56h0a92.69,92.69,0,0,0,3-10.6,69.45,69.45,0,0,0,1.42-9c.19-2.51.07-4.17-.36-5-.36-.64-1.07-.58-2.11.18a22.46,22.46,0,0,0-4.25,5.07,122.14,122.14,0,0,0-6.6,11.28q-4.43,8.43-8.39,18.2a190.93,190.93,0,0,0-6.67,19.19,89.36,89.36,0,0,0-3,15.55q-.69,7.27.5,9.94c.71,1.28,2,1.63,3.83,1.06a17,17,0,0,0,6.3-4.38,118.79,118.79,0,0,0,10.67-13.11q6.24-8.61,13.58-20.56C184.1,91.46,184.18,91.44,184.24,91.53Z' />
						<path d='M54.21,37C56.06,21,64.85,8.87,80.27,3.88A40.7,40.7,0,0,1,103,3.12c11.12,3,13.75,13.38,10.8,22.93s-7.68,14.71-11.67,21.53c-4.57,7.8-7.9,12.78-13.9,23-3.83,6.53-8.67,15.28-9.59,23.7a7.29,7.29,0,0,0,4.36,7.4c-.33-.15-.91-1.53-1.55-1.83C76.17,97.42,85.6,78.79,87.08,76c4.68-8.73,9.63-16.7,14.75-25.19,8.46-14,19.37-26.78,11.39-40.91-6-10.67-20.39-11.08-31.3-8.79-17,3.57-27,17.29-29,34.15-.07.67-.26,1.14-.31,1.51Z' />
						<path d='M111,102.71c2.42-2,6.14-4.41,8.79-4.62' />
						<path d='M132.52,96.23c.37.64-.23.78-.23.78.08-.18-.22.16-.34.34-1.43,1.85-3.29,3.45-5.25,5.91q-2.74,3.42-5.37,6.4a39.47,39.47,0,0,1-4.54,4.51c-1.28,1-2.12,1.23-2.51.61A6.21,6.21,0,0,1,114,111a34.08,34.08,0,0,1,1.46-5.55c.71-2.09,1.5-4.28,2.38-6.59l.37-1c.12-.33.23-.64.34-.92s.23-.6.35-1a1.72,1.72,0,0,1,.79-.85,2.16,2.16,0,0,1,1.11-.28.68.68,0,0,1,.71.48,1.53,1.53,0,0,1,0,.9,3.59,3.59,0,0,1-.38.82c-.11.21-.22.44-.35.7a3.11,3.11,0,0,1-.34.65c-.49,1-1.15,2.35-2,4.21a54.51,54.51,0,0,0-2.3,5.66,9.63,9.63,0,0,0-.73,4.5q.45,1.26,4.18-2.42c2.48-2.46,6.32-7.25,11.84-14.3C131.57,95.91,132,95.38,132.52,96.23Zm-10.47-6c-.22,0-.31-.22-.28-.5a8.37,8.37,0,0,1,.18-1,5.34,5.34,0,0,0,.2-.88,4.72,4.72,0,0,1,.48-1.56,1,1,0,0,1,.82-.59,1.57,1.57,0,0,1,.61.11.74.74,0,0,1,.35.62,4.45,4.45,0,0,1-.09,1.54,3,3,0,0,1-1,2,1.55,1.55,0,0,1-1.27.23Z' />
					</g>
				</g>
			</svg>
		</Link>
	);
};

Logo.propTypes = {
	white: PropTypes.bool,
	stroke: PropTypes.bool,
	noType: PropTypes.bool,
	className: PropTypes.string,
};

Logo.defaultProps = {
	white: false,
	stroke: false,
	noType: false,
	className: '',
};

export default Logo;
